import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import CloudyLogo from '../CloudyLogo'

function NavLogo() {
  const logoRef = useRef()

  useEffect(() => {
    const logo = logoRef.current
    logo?.playSequence(
      [
        'idle:3000',
        'blink',
        'idle:2000',
        'looking-right:1500',
        'idle:1000',
        'blink',
        'looking-left:1500',
        'idle:2000',
        'happy:2000',
        'idle:1000',
        'wink',
        'idle:3000',
      ],
      true
    )
    return () => logo?.stopSequence()
  }, [])

  return <CloudyLogo ref={logoRef} size={32} theme="dark" />
}

const NAV_LINKS = [
  { label: 'Fonctionnalités', href: '#features' },
  { label: 'Sécurité', href: '#security' },
  { label: 'IA', href: '#ai' },
  { label: 'Tarifs', href: '#pricing' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollTo = (href) => {
    setMobileOpen(false)
    const el = document.querySelector(href)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <>
      <nav className={`landing-navbar${scrolled ? ' landing-navbar--scrolled' : ''}`}>
        <button className="landing-navbar__logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <NavLogo />
          Cloudy Pocket
        </button>

        <ul className="landing-navbar__links">
          {NAV_LINKS.map(link => (
            <li key={link.href}>
              <a href={link.href} onClick={(e) => { e.preventDefault(); scrollTo(link.href) }}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="landing-navbar__actions">
          <a href={process.env.REACT_APP_APP_URL + '/connexion'} className="landing-navbar__btn landing-navbar__btn--ghost">
            Se connecter
          </a>
          <a href={process.env.REACT_APP_APP_URL + '/nouveau_compte'} className="landing-navbar__btn landing-navbar__btn--primary">
            Créer un compte
          </a>
          <button className="landing-navbar__hamburger" onClick={() => setMobileOpen(true)} aria-label="Menu">
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </nav>

      <div className={`landing-navbar__mobile-menu${mobileOpen ? ' landing-navbar__mobile-menu--open' : ''}`}>
        <button className="landing-navbar__mobile-menu__close" onClick={() => setMobileOpen(false)} aria-label="Close menu">
          <FontAwesomeIcon icon={faXmark} />
        </button>
        {NAV_LINKS.map(link => (
          <a key={link.href} href={link.href} onClick={(e) => { e.preventDefault(); scrollTo(link.href) }}>
            {link.label}
          </a>
        ))}
        <a href={process.env.REACT_APP_APP_URL + '/connexion'}>Se connecter</a>
        <a href={process.env.REACT_APP_APP_URL + '/nouveau_compte'} className="landing-navbar__btn landing-navbar__btn--primary">
          Créer un compte
        </a>
      </div>
    </>
  )
}
